import {
  getAll,
  createAttendance,
  deleteAttendance,
  updateAttendance,
  getAttendanceByLesson,
  submitAttendance,
} from "../../services/attendance";
import { actionTypes, actions } from "../actions/attendance";
import { put, takeLatest, call } from "redux-saga/effects";
import { toast } from "../../app/components/Toastr";

export default function* saga() {
  yield takeLatest(actionTypes.GetList, function* getList() {
    yield put(
      actions.setState({
        meta: {
          list: {
            loading: true,
          },
        },
      })
    );
    try {
      const result = yield call(getAll);
      return yield put(
        actions.setState({
          list: result.data.results,
          meta: null,
        })
      );
    } catch (error) {
      return yield put(
        actions.setState({
          meta: {
            list: {
              loading: false,
            },
          },
        })
      );
    }
  });

  yield takeLatest(actionTypes.GetListByLesson, function* getAttendance(
    payload
  ) {
    yield put(
      actions.setState({
        meta: {
          list: {
            loading: true,
          },
        },
      })
    );
    try {
      const result = yield call(getAttendanceByLesson, payload);
      return yield put(
        actions.SetListByLessons({
          lessonAttendance: result.data.results,
          meta: null,
        })
      );
    } catch (error) {
      return yield put(
        actions.setState({
          meta: {
            list: {
              loading: false,
            },
          },
        })
      );
    }
  });

  yield takeLatest(actionTypes.SubmitAttendance, function* createAttend({
    payload,
  }) {
    try {
      const result = yield call(submitAttendance, payload);
      toast.success("Attendance submitted successfully!");
    } catch (error) {
      toast.error(error.response.data.error);
    }
  });

  yield takeLatest(actionTypes.CreateAttendance, function* createAttend(
    payload
  ) {
    try {
      const result = yield call(createAttendance, payload.payload);
      toast.success(result.data.message);
    } catch (error) {
      toast.error(error.response.data.error);
    }
  });
}
